module.exports = __webpack_public_path__ + "41ff765a43a5abdfed7b3df411ec62d2.png";